/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { fonts } from '@theme/index';

const ExportMessageContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    width: 580px;
    padding: 56px;
    box-sizing: border-box;
`;

const ExportMessageTitleStyled = styled.span.attrs({
    className: 'export-message__title',
})`
    ${fonts.textHeader3};
`;

const ExportMessageDescriptionStyled = styled.span.attrs({
    className: 'export-message__description',
})`
    word-break: break-word;
    ${fonts.textMain};
`;

const FooterContainerStyled = styled.div.attrs({
    className: 'export-message__footer',
})`
    display: flex;
    margin-top: 24px;

    & .export-message__cancel-btn {
        display: flex;
        align-items: center;
        margin-left: 16px;
    }
`;

export {
    ExportMessageContainerStyled,
    ExportMessageDescriptionStyled,
    ExportMessageTitleStyled,
    FooterContainerStyled,
};
